import { FC } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { cn } from '~/core/ui/utils'
import ContactRequestButton from './components/ContactRequestButton'

const ApplicantTrackingCRMJoinSection: FC = () => {
  const { t } = useTranslation()

  return (
    <div className="bg-blue-50 relative overflow-hidden">
      <img
        src="/img/feature/lp/hero-background.png"
        alt="Background"
        className={cn(
          'absolute -top-10 left-12 size-[250px] object-cover rotate-[-35deg]',
          'tablet:left-0 tablet:size-[500px] tablet:right-[30%]'
        )}
      />
      <div className="flex flex-col tablet:flex-row items-center space-y-10 tablet:space-y-0">
        <div className="px-4 flex flex-col w-full tablet:w-2/5 tablet:min-w-72 ml-[max(50vw-608px,16px)]">
          <div className="font-medium tablet:text-left text-4xl tablet:4.5xl mt-3 tablet:mt-[44px] flex space-x-1">
            <Trans i18nKey="applicant_tracking_crm:join:title">
              <p />
              <p className="text-primary-400" />
            </Trans>
          </div>
          <div
            className="mt-3 table:mt-4 text-lg tablet:text-left text-gray-900"
            dangerouslySetInnerHTML={{
              __html: `${t('applicant_tracking_crm:join:description')}`
            }}
          />
          <div className="tablet:mx-0 mt-6 tablet:mt-4">
            <ContactRequestButton
              label={t('applicant_tracking_crm:join:button')}
            />
          </div>
        </div>
        <div className="flex-1 h-full">
          <img
            alt="Why Hireforce"
            src="/img/feature/applicant-tracking-crm/join.png"
            className="h-full w-full object-contain hidden tablet:block"
          />
          <img
            alt="Why Hireforce"
            src="/img/feature/applicant-tracking-crm/join-mobile.png"
            className="h-full w-full object-contain tablet:hidden"
          />
        </div>
      </div>
    </div>
  )
}

export default ApplicantTrackingCRMJoinSection
